"use client";

import { ScrollableSliderDesktop } from "@/app/components/ScrollableSliderDesktop";
import { ScrollableSliderMobile } from "@/app/components/ScrollableSliderMobile";
import React from "react";
import { useMediaQuery } from "@/app/hooks/useMediaQuery";

export interface ScrollableSliderProps {
  data: {
    slide: {
      id: number;
      textA?: string;
      textB?: string;
      description?: string;
      image: {
        data: {
          attributes: {
            url?: string;
          };
        };
      };
    }[];
  };
}

export const ScrollableSlider = ({ data }: ScrollableSliderProps) => {
  const isMobile = useMediaQuery("(max-width:560px)");

  if (isMobile === null) {
    return (
      <div className="py-[44px] dt:py-[130px] px-9 dt:px-[108px] min-[561px]:flex justify-center items-center">
        <section className="dt:w-[80%]" aria-hidden="true">
          <div className="h-[640px] w-full rounded-[8px] bg-transparent" />
        </section>
      </div>
    );
  }

  return (
    <div className="py-[44px] dt:py-[130px] px-9 dt:px-[108px] min-[561px]:flex justify-center items-center">
      <section className="dt:w-[80%]">
        <h1 className="tracking-wider font-bold uppercase text-2.25 leading-2.25 dt:text-[4.5rem] dt:leading-[4.5rem] text-[#161616] w-full mx-auto text-center mb-[30px]">
          Charter Bus Rental Options
        </h1>
        {isMobile ? (
          <ScrollableSliderMobile data={data} />
        ) : (
          <ScrollableSliderDesktop data={data} />
        )}
      </section>
    </div>
  );
};
